import { ReportFeatures } from '@hcs/types';

export const COMP_TRANSACTION_HISTORY_FEATURES_SALE = [
  ReportFeatures.CompsTransactionHistory,
];
export const COMP_TRANSACTION_HISTORY_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsTransactionHistory,
];
export const dataHcEventSectionCompHistoryRental =
  'Rental Comp Transaction History';
export const dataHcEventSectionCompHistorySale = 'Comp Transaction History';
